import { Flex } from "@chakra-ui/react";
import { WriteLeftDotLine } from "../../ComponentLayouter/WriteLeftDotLine";
import { AddMarginLeft } from "../../ComponentLayouter/AddMarginLeft";

export const SpotStatDummy = () => {
  return (
    <Flex
      alignItems="baseline"
      borderBottom={""}
      data-testid={"spot-stat-dummy"}
    >
      －
    </Flex>
  );
};
